import { LineSkeleton } from 'components/base/Skeletons';

const Loader = () => {
  const linesSizes = [40, 50, 30, 50];
  return (
    <div className='w-full h-full py-5 flex flex-col items-start justify-center'>
      {linesSizes.map((size, index) => (
        <div className='mb-2 w-full' key={index}>
          <LineSkeleton size={size} />
        </div>
      ))}
    </div>
  );
};

export default Loader;
